import { ActionTree } from 'vuex';
import { CommonServices } from '../../services/common.services';
import { ConfigurationServices } from '../../services/configuration.service';
import { ApiResponse } from '../../models/app-configuration';

import {
    IAppConfigState,
    ISystemConfigInfo,
    APP_CONFIG_MODULE_TYPES
} from './app-config-types.store';

// Share one request between concurrent callers so the config info is only fetched once
let systemConfigInfoRequest: Promise<ISystemConfigInfo> = null;

export const actions: ActionTree<IAppConfigState, any> = {
    [APP_CONFIG_MODULE_TYPES.GET_FORM_DATA_CONFIG_BY_TYPE]: ({ commit, state }, type: string) => {
        if (state.formDataConfigs[type]) {
            return Promise.resolve(state.formDataConfigs[type]);
        }
        return new CommonServices().getFormDataConfigByType(type).then(data => {
            commit(APP_CONFIG_MODULE_TYPES.GET_FORM_DATA_CONFIG_BY_TYPE, {
                key: type,
                value: data
            });
            return Promise.resolve(data);
        });
    },
    [APP_CONFIG_MODULE_TYPES.GET_SYSTEM_CONFIG]: ({ commit, state }, type: string) => {
        if (state.systemAppConfigs[type]) {
			return Promise.resolve(state.systemAppConfigs[type]);
        }
		return new CommonServices().getConfigDataByKey({
			userConfigKeys: [],
			systemConfigKeys: [type]
		}).then(data => {
			console.log(data);
			const value = data.SystemConfigs[type];
            commit(APP_CONFIG_MODULE_TYPES.SET_SYSTEM_CONFIG, {
                key: type,
				value: value
            });
			return Promise.resolve(value);
        });
    },
    [APP_CONFIG_MODULE_TYPES.GET_USER_CONFIG]: ({ commit, state }, type: string) => {
        if (state.userAppConfigs?.[type]) {
			return Promise.resolve(state.userAppConfigs[type]);
        }
		return new CommonServices().getConfigDataByKey({
			userConfigKeys: [type],
			systemConfigKeys: []
		}).then(data => {
			const value = data?.UserConfigs?.[type]
            commit(APP_CONFIG_MODULE_TYPES.SET_USER_CONFIG, {
                key: type,
				value: value
            });
			return Promise.resolve(value);
        });
    },
    [APP_CONFIG_MODULE_TYPES.GET_SYSTEM_CONFIG_INFO]: ({ commit, state }, payload?: { forceRefresh?: boolean }): Promise<ISystemConfigInfo> => {
        if (payload?.forceRefresh) {
            // Drop both caches (state + in-flight promise) so the configs are re-fetched
            commit(APP_CONFIG_MODULE_TYPES.SET_SYSTEM_CONFIG_INFO, null);
            systemConfigInfoRequest = null;
        }
        if (state.systemConfigInfo) {
            return Promise.resolve(state.systemConfigInfo);
        }
        if (!systemConfigInfoRequest) {
            systemConfigInfoRequest = new ConfigurationServices()
                .getSystemConfigs({ Enquiry: true, Tasks: true, PropertyStatus: true })
                .then((response: ApiResponse) => {
                    if (!response.isSuccess) {
                        systemConfigInfoRequest = null;
                        return Promise.reject(response.message);
                    }
                    const info: ISystemConfigInfo = response.data || {};
                    commit(APP_CONFIG_MODULE_TYPES.SET_SYSTEM_CONFIG_INFO, info);
                    return info;
                })
                .catch(error => {
                    // Allow a retry on the next call instead of caching the failure
                    systemConfigInfoRequest = null;
                    return Promise.reject(error);
                });
        }
        return systemConfigInfoRequest;
    },
    [APP_CONFIG_MODULE_TYPES.SET_USER_CONFIG]: ({ commit }, config: { key: string, value: any}) => {
        commit(APP_CONFIG_MODULE_TYPES.SET_USER_CONFIG, config);
    },
    [APP_CONFIG_MODULE_TYPES.SET_SYSTEM_CONFIG]: ({ commit }, config: { key: string, value: any}) => {
        commit(APP_CONFIG_MODULE_TYPES.SET_SYSTEM_CONFIG, config);
    },
    [APP_CONFIG_MODULE_TYPES.UPDATE_CONFIG_VALUE]: ({ commit, state }, config: {key: string, value: string}) => {
        commit(APP_CONFIG_MODULE_TYPES.UPDATE_CONFIG_VALUE, config);
    }

}